import React, {useEffect, useState} from "react";
import {THEMES, chooseTheme, currentTheme, onThemeChanged} from "../utils/theme";
import "./ThemePicker.css";

/**
 * "Cor do app": one option per accent color, a round swatch with its name.
 * Choosing one applies it right away and remembers it on this device. When
 * `save` is given it is also asked to keep the choice (it returns a promise);
 * if that fails the previous color comes back and `onSaveError` is called.
 *
 * @param {{
 *   save?: (id: string) => Promise<unknown>,
 *   onSaveError?: () => void,
 *   disabled?: boolean,
 * }} props
 */
const ThemePicker = ({save, onSaveError, disabled = false}) => {
    const [current, setCurrent] = useState(currentTheme);

    // The saved theme arrives from the server after the page is up.
    useEffect(() => onThemeChanged(() => setCurrent(currentTheme())), []);

    const choose = async (id) => {
        const previous = current;
        chooseTheme(id);
        if (!save) return;
        try {
            await save(id);
        } catch {
            chooseTheme(previous);
            onSaveError?.();
        }
    };

    return (
        <div className="d-flex flex-wrap gap-2" role="group" aria-label="Cor do app">
            {THEMES.map(({id, label, color, swatch}) => (
                <button
                    key={id}
                    type="button"
                    className="theme-option"
                    style={{color}}
                    aria-pressed={current === id}
                    disabled={disabled}
                    onClick={() => choose(id)}
                >
                    <span className="theme-swatch" style={{background: swatch ?? color}} />
                    <span className="theme-option__name">{label}</span>
                </button>
            ))}
        </div>
    );
};

export default ThemePicker;
